import {useDispatch, useSelector} from 'react-redux';
import {push} from 'connected-react-router';
import InternalAlerts from '../../components/InternalAlerts/internalAlerts';
import React, {useEffect, useState} from 'react';
import {requestLawsysFirmsWithAgents} from '../../actions/lawsysFirms';
import usePrevious from '../../hooks/usePrevious';
import {
  changeInternalAlertsSettings,
  getInternalAlerts,
} from '../../reducers/internalAlerts';

const InternalAlertsHOC = props => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const internalAlerts = useSelector(state => state.internalAlerts);
  const lawsysFirms = useSelector(state => state.lawsysFirms);
  const caseTypes = useSelector(state => state.caseTypes);

  const prevPage = usePrevious(internalAlerts.page);
  const prevRowsPerPage = usePrevious(internalAlerts.rowsPerPage);

  const [filterOptions, setFilterOptions] = useState({
    caseTypeOptions: caseTypes.cases,
    subCaseTypeOptions: caseTypes.subCases,
  });
  useEffect(() => {
    dispatch(requestLawsysFirmsWithAgents(user.loggedInUser.token));
  }, []);

  useEffect(() => {
    if (
      prevPage != internalAlerts.page ||
      prevRowsPerPage != internalAlerts.rowsPerPage
    ) {
      var filter = getQueryParams();
      dispatch(getInternalAlerts(filter));
    }
  }, [
    internalAlerts.rowsPerPage,
    internalAlerts.page,
    prevPage,
    prevRowsPerPage,
  ]);

  useEffect(() => {
    let subCases = caseTypes.subCases;
    let newSelectedSubCases = internalAlerts.filterSubCaseTypes;
    if (internalAlerts.filterCaseTypes.length > 0) {
      //filter sub case types options for selected case types
      const caseTypesIds = internalAlerts.filterCaseTypes.map(c => c.key);
      subCases = subCases.filter(c => caseTypesIds.includes(c.caseTypeId));
      if (internalAlerts.filterSubCaseTypes.length > 0) {
        const validSubCasesIds = subCases.map(c => c.id);
        newSelectedSubCases = newSelectedSubCases.filter(c =>
          validSubCasesIds.includes(c.key),
        );
      }
    }
    setFilterOptions({...filterOptions, subCaseTypeOptions: subCases});
    dispatch(
      changeInternalAlertsSettings({
        key: 'filterSubCaseTypes',
        value: newSelectedSubCases,
      }),
    );
  }, [internalAlerts.filterCaseTypes]);

  const getQueryParams = () => {
    const validFrom = internalAlerts.filterValidFrom
      ? new Date(internalAlerts.filterValidFrom)?.toISOString()
      : '';
    const validTo = internalAlerts.filterValidTo
      ? new Date(internalAlerts.filterValidTo.setHours(23,59,59)).toISOString()
      : '';
    const params = {
      limit: internalAlerts.rowsPerPage,
      offset: (internalAlerts.page - 1) * internalAlerts.rowsPerPage,
      filterCaseTypes: internalAlerts.filterCaseTypes,
      filterSubCaseTypes: internalAlerts.filterSubCaseTypes,
      filterFirms: internalAlerts.filterFirms,
      filterValidFrom: validFrom,
      filterValidTo: validTo,
      filterSearch: internalAlerts.filterSearch,
    };
    return params;
  };

  const applyFilters = () => {
    const params = getQueryParams();
    dispatch(getInternalAlerts(params));
  };

  const clearFilters = () => {
    dispatch(
      changeInternalAlertsSettings({
        key: 'clearFilters',
        value: 'clearFilters',
      }),
    );
    var params = {
      limit: 20,
      offset: 0,
      filterCaseTypes: [],
      filterSubCaseTypes: [],
      filterFirms: [],
      filterValidFrom: '',
      filterValidTo: '',
      filterSearch: '',
    };
    dispatch(getInternalAlerts(params));
  };
  const viewInternalAlert = internalAlertId => {
    dispatch(push('/internal-alerts/' + internalAlertId));
  };

  return (
    <InternalAlerts
      push={e => dispatch(push(e))}
      user={user}
      internalAlerts={internalAlerts}
      lawsysFirms={lawsysFirms}
      filterOptions={filterOptions}
      applyFilters={applyFilters}
      clearFilters={clearFilters}
      changeInternalAlertsSettings={(key, value) =>
        dispatch(
          changeInternalAlertsSettings({
            key,
            value,
          }),
        )
      }
    />
  );
};
export default InternalAlertsHOC;
